
export default class Grid extends THREE.GridHelper {
  constructor (unit, size, division, color1, color2) {
    super(size, division, color1, color2);
    this.unit = unit;
    this.size = size;
    this.color1 = color1;
    this.color2 = color2;
  }

  contains (bb) {
    const center = bb.center;
    const size = bb.size;
    const hsize = this.size * 0.5;
    const dx = Math.abs(center.x) + size.x * 0.5;
    const dz = Math.abs(center.z) + size.x * 0.5;
    return dx < hsize && dz < hsize;
  }

  expand (bb) {
    const center = bb.center;
    const size = bb.size;
    const padding = this.unit * 2;
    const gx = Math.ceil((Math.abs(center.x) + size.x * 0.5) / this.unit) * this.unit + padding;
    const gz = Math.ceil((Math.abs(center.z) + size.z * 0.5) / this.unit) * this.unit + padding;
    const newSize = Math.max(Math.max(gx, gz) * 2, this.size);
    const source = new THREE.GridHelper(newSize, Math.floor(newSize / this.unit), this.color1, this.color2);
    this.copy(source);

    this.size = newSize;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/misc/Grid.js